var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prelative" }, [
    _c("header", { staticClass: "flex-level jc-space mb-4" }, [
      _c("div", { staticClass: "flex-row ai-center" }, [
        _c("h2", { staticClass: "m-0" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$l10n.__("Rapport d'activité CRM")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-4" },
          [
            _c("tabs-nav", {
              attrs: { tabs: _vm.tabs, activeTab: _vm.type },
              on: { "tab-clicked": _vm.changeType }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row" },
        [
          _c(
            "el-button-group",
            { staticClass: "view" },
            [
              _c(
                "el-button",
                {
                  class: { isActive: _vm.isActiveView("chart") },
                  on: {
                    click: function($event) {
                      return _vm.changeView("chart")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$l10n.__("Vue graphique")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  class: { isActive: _vm.isActiveView("listing") },
                  attrs: { disabled: _vm.type === "label" },
                  on: {
                    click: function($event) {
                      return _vm.changeView("listing")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$l10n.__("Vue liste")))]
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-column pb-5" },
      [
        _c("report-filters"),
        _vm._v(" "),
        _c("router-view", { key: _vm.$route.path })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }